module.exports = __webpack_public_path__ + "nc_static/media/refresh-circle.2400dd02.svg";